import script from "./UsuariosRegistrados.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuariosRegistrados.vue?vue&type=script&setup=true&lang=js"

import "./UsuariosRegistrados.vue?vue&type=style&index=0&id=76ce62f3&scoped=true&lang=css"
import "./UsuariosRegistrados.vue?vue&type=style&index=1&id=76ce62f3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76ce62f3"]])

export default __exports__